/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shivam Kumar",
  title: "Hey, I'm",
  name: "Shivam",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1f63QB3gNIvFyAKV513ae98S6bykW0MoB/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/rhinoxD",
  linkedin: "https://www.linkedin.com/in/the-shivamkumar/",
  twitter: "https://twitter.com/shivamszero",
  gmail: "shivamsk0721@gmail.com",
  // gitlab: "https://gitlab.com/rhinoxD",
  // medium: "https://medium.com/@shivamsk0721",
  hashnode: "https://shivamszero.hashnode.dev/",
  stackoverflow: "https://stackoverflow.com/users/15412566/shivam",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services such as Firebase/AWS")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "boostrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // {
    //   schoolName: "Harvard University",
    //   logo: require("./assets/images/harvardLogo.png"),
    //   subHeader: "Master of Science in Computer Science",
    //   duration: "September 2017 - April 2019",
    //   desc: "Participated in the research of XXX and published 3 papers.",
    //   descBullets: [
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //   ]
    // },
    {
      schoolName: "Guru Gobind Singh Indraprastha University",
      logo: require("./assets/images/ggsipuLogo.png"),
      subHeader: "Bachelor of Computer Applications",
      duration: "August 2019 - August 2022",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ..."
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    },
    {
      schoolName: "St. Mary's School, Dwarka",
      logo: require("./assets/images/stmarysLogo.jpg"),
      subHeader: "10th and 12th",
      duration: "Apr 2017 - Mar 2019"
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "75%"
    },
    {
      Stack: "Programming",
      progressPercentage: "75%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

// const workExperiences = {
//   display: true, //Set it to true to show workExperiences Section
//   experience: [
//     {
//       role: "Software Engineer",
//       company: "Facebook",
//       companylogo: require("./assets/images/facebookLogo.png"),
//       date: "June 2018 – Present",
//       desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//       descBullets: [
//         "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
//         "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
//       ]
//     },
//     {
//       role: "Front-End Developer",
//       company: "Quora",
//       companylogo: require("./assets/images/quoraLogo.png"),
//       date: "May 2017 – May 2018",
//       desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
//     },
//     {
//       role: "Software Engineer Intern",
//       company: "Airbnb",
//       companylogo: require("./assets/images/airbnbLogo.png"),
//       date: "Jan 2015 – Sep 2015",
//       desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
//     }
//   ]
// };

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

// const bigProjects = {
//   title: "Big Projects",
//   subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
//   projects: [
//     {
//       image: require("./assets/images/saayaHealthLogo.webp"),
//       projectName: "Saayahealth",
//       projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
//       footerLink: [
//         {
//           name: "Visit Website",
//           url: "http://saayahealth.com/"
//         }
//         //  you can add extra buttons here.
//       ]
//     },
//     {
//       image: require("./assets/images/nextuLogo.webp"),
//       projectName: "Nextu",
//       projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
//       footerLink: [
//         {
//           name: "Visit Website",
//           url: "http://nextu.se/"
//         }
//       ]
//     }
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Cyber Security Essentials",
      subtitle:
        "Completed the Cisco Networking Academy Cybersecurity Essentials Course",
      image: require("./assets/images/cyber.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1a5tnzZLCue_k1l-QPwH4WHYxjIml-Ezu/view?usp=sharing"
        }
      ]
    },
    // {
    //   title: "Crash Course on Python",
    //   subtitle: "Completed Certification from Coursera for Python",
    //   image: require("./assets/images/python.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1S8YKv9N_4DMNpMjk7l2SdYAT_3o37Uou/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Using Python to Interact with the Operating System",
    //   subtitle:
    //     "Completed Certification from Coursera for Google IT Automation with Python",
    //   image: require("./assets/images/os.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/11g5kxVY9owJIE1DmjSdx6oqUHD-bL_3F/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Introduction to Git and GitHub",
    //   subtitle:
    //     "Completed Certification from Coursera for Google IT Automation with Python",
    //   image: require("./assets/images/git.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1vdtBl_bkDHoql2xSWR87B7LAZ3Cy-ygI/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Troubleshooting and Debugging Techniques",
    //   subtitle:
    //     "Completed Certification from Coursera for Google IT Automation with Python",
    //   image: require("./assets/images/debug.png"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1oE8bDZnIKKngsFwPBDexfQ5xJp_p2czp/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Configuration Management and the Cloud",
    //   subtitle:
    //     "Completed Certification from Coursera for Google IT Automation with Python",
    //   image: require("./assets/images/cloud.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1Wp_-zehd8TItwv38lCSjFlPgWHG_CBW5/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Automating Real-World Tasks with Python",
    //   subtitle:
    //     "Completed Certification from Coursera for Google IT Automation with Python",
    //   image: require("./assets/images/auto2.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/16bIEmG8GPKAvamnBamZGLL1qAZZw2VMR/view?usp=sharing"
    //     }
    //   ]
    // },
    {
      title: "Google IT Automation with Python",
      subtitle:
        "Completed Specialization Course from Coursera for Google IT Automation with Python",
      image: require("./assets/images/auto2.jpg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1vp7atWJCyMpP_yNVLjFmy-_XOjYlJ24Z/view?usp=sharing"
        }
      ]
    },
    {
      title: "Web App Developer",
      subtitle: "Completed Certifcation from Udemy for Web App Development",
      image: require("./assets/images/wa.jpg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1YzSJKKX6HD4Nr04ukgpfT_h2yfJ_KWYS/view?usp=sharing"
        }
        // {
        //   name: "Final Project",
        //   url: "https://gocamp-rhino.herokuapp.com/"
        // }
      ]
    },
    // {
    //   title: "Introduction to Cybersecurity Tools & Cyber Attacks",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/c1.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1EZjfijvsGzzS-3o1JQCxrEJkXahbkNfK/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Cybersecurity Roles, Processes & Operating System Security",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/c2.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1sDdAm9j9qz-rf6DNhey4VmwFWwy0FYqk/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Cybersecurity Compliance Framework and System Administration",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/c3.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1ZhSp42LhZzrsbMdo92q4xPCJs6UNFd-S/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Network Security and Database Vulnerabilities",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/c4.webp"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/10nYpwjnbYmQNXoYTzsQw6eCkH_wX2gWR/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Penetration Testing, Incident Response and Forensics",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/c5.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1TcR73Qaed7Zi7nRftjs4te4qktOodMtZ/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Cyber Threat Intelligence",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/cyberthreat.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1JTytR5Dh_Ce3S781h8eGFD_k-j1DMjBk/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "Cybersecurity Capstone: Breach Response Case Studies",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/capstone.jpg"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/10WIYBrB0QSobt_UjHRuyFewSYhfuoZFP/view?usp=sharing"
    //     }
    //   ]
    // },
    // {
    //   title: "IBM Cybersecurity Analyst Assessment",
    //   subtitle:
    //     "Completed Certification from Coursera for IBM Cybersecurity Analyst",
    //   image: require("./assets/images/canal.webp"),
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: "https://drive.google.com/file/d/1v9dNG3XHsjiNBQeybxVvpEJV8mL7f-hk/view?usp=sharing"
    //     }
    //   ]
    // },
    {
      title: "IBM Cybersecurity Analyst",
      subtitle:
        "Completed Specialization Course from Coursera for IBM Cybersecurity Analyst",
      image: require("./assets/images/canal2.jpg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1eedgvgv9_kIMa_E7raQkurgwGgSHLPIQ/view?usp=sharing"
        }
      ]
    },
    {
      title: "Meta Front-End Developer",
      subtitle:
        "Completed Specialization Course from Coursera for Meta Front-End Developer",
      image: require("./assets/images/fe.jpg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/13HXOL7AcUeD4Rm_0Ore_95SuYEWEv5FI/view?usp=share_link"
        }
      ]
    },
    {
      title: "AWS Fundamentals",
      subtitle:
        "Completed Specialization Course from Coursera for AWS Fundamentals",
      image: require("./assets/images/aws1.jpg"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1NqUJ6CYo4RETI1dTYtdXvHMZKnJzqf1s/view?usp=share_link"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  // displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://shivamszero.hashnode.dev/why-react-is-the-best",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    },
    {
      url: "https://shivamszero.hashnode.dev/understanding-flexbox",
      title: "Understanding flexbox",
      description:
        "Much like the div and box container that you can create using HTML, flexbox is a type of container. Flexbox can overcome the limitations caused by..."
    },
    {
      url: "https://shivamszero.hashnode.dev/the-only-git-cheat-sheet-youll-ever-need",
      title: "The Only Git Cheat Sheet You'll Ever Need",
      description:
        "Git is the open source distributed version control system that facilitates GitHub activities on your laptop or desktop. This cheat sheet summarizes commonly used Git command line instructions for quick reference."
    },
    {
      url: "https://shivamszero.hashnode.dev/open-source-for-beginners-a-guide-to-getting-involved",
      title: "Open Source for Beginners: A Guide to Getting Involved",
      description:
        "From a beginner's point of view, we have been using open source projects ever since we were kids. So, for example, I was using VLC when I was a kid, google chrome, chromium, firefox and we have the programming languages that we're using."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "user@gmail.com"
};

// Twitter Section

// const twitterDetails = {
//   userName: "twitter", //Replace "twitter" with your twitter username without @
//   display: true // Set true to display this section, defaults to false
// };

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  // workExperiences,
  openSource,
  // bigProjects,
  achievementSection,
  blogSection,
  // talkSection,
  // podcastSection,
  contactInfo
  // twitterDetails
};
